<template>
  <div class="rolling-wrap" v-if="firstMsg">
    <div class="roll-area">
      <div class="roll-item-wrap upitem" @click="handleClick(firstMsg)" :style="{transform: 'translateY('+fisrtTsY+'%)'}">
        <span class="roll-type" :class="firstMsg.type=='news' ? 'news' : 'promo'">{{firstMsg.type=='news' ? geti18n('新闻'): geti18n('推荐')}}</span>
        <div class="roll-title">{{firstMsg.title}}</div>
      </div>
      <div class="roll-item-wrap downitem" v-if="secondMsg" :style="{transform: 'translateY('+secondTsY+'%)'}"  @click="handleClick(secondMsg)">
        <span class="roll-type" :class="secondMsg.type=='news' ? 'news' : 'promo'">{{secondMsg.type=='news' ? geti18n('新闻'): geti18n('推荐')}}</span>
        <div class="roll-title">{{secondMsg.title}}</div>
      </div>
      <i class="roll-icon-arrow"></i>
    </div>
    <div class="news-wrap" v-if="clickedNews" :class="showNews ? '' : 'hide'" touchmove="return false">
      <div class="mask" @click="closeNews"></div>
      <div class="news-container" :class="startUp ? 'active' : 'inactive'">
        <div class="title-area">
          <div class="delete" @click="closeNews">x</div>
          <div class="title-text">{{clickedNews.title}}</div>
        </div>
        <div class="content-area">
          <div class="time">{{clickedNews.time}}</div>
          <div class="content-text">{{clickedNews.content}}</div>
          <div class="source">{{clickedNews.source}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { biHottag, language, url } from '@tencent/ppd-base-libs';
import { i18n } from '@/i18n';
const lang = language.getLanguage();
export default {
  name: 'roll-message',

  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      lang,
      showNews: false, // 显示新闻
      startUp: false, // 上滑出现的动画控制
      nextIndex: 2, // 下一条滚动信息的index值
      upper: 1, // 记录滚动的两条的上面的是哪个
      fisrtTsY: 0, // 用transformY控制轮播
      secondTsY: 120,
      clickedNews: null, // 点击的新闻
      firstMsg: null,
      secondMsg: null,
    };
  },
  methods: {
    init() {
      if (this.list[0]) this.firstMsg = this.list[0];
      if (this.list[1]) this.secondMsg = this.list[1];
      setTimeout(this.startRoll, 1000);
    },
    // 开始轮播
    startRoll() {
      if (!this.secondMsg) return;
      this.rollTimer = setInterval(() => {
        this.fisrtTsY -= 5;
        this.secondTsY -= 5;

        if (this.fisrtTsY <= -120) {
          this.fisrtTsY = 120;
          clearInterval(this.rollTimer);
          this.rollTimer = null;
          setTimeout(this.startRoll, 800);
          if (this.nextIndex >= this.list.length) this.nextIndex = 0;
          this.firstMsg = this.list[this.nextIndex];
          this.nextIndex += 1;
        }
        if (this.secondTsY <= -120) {
          this.secondTsY = 120;
          clearInterval(this.rollTimer);
          this.rollTimer = null;
          setTimeout(this.startRoll, 800);
          if (this.nextIndex >= this.list.length) this.nextIndex = 0;
          this.secondMsg = this.list[this.nextIndex];
          this.nextIndex += 1;
        }
      }, 50);
    },
    geti18n(str) {
      return i18n(str);
    },
    handleClick(msg) {
      biHottag('wallet.cvirus.home.carousel_click');

      if (msg.type == 'news') {
        this.openNews(msg);
      } else if (msg.type == 'recommend') {
        setTimeout(() => {
          window.location.href = msg.jump_link;
        }, 300);
      }
    },
    // 显示新闻
    openNews(msg) {
      this.clickedNews = msg;
      this.showNews = true;
      setTimeout(() => {
        this.startUp = true;
      }, 50);
    },
    closeNews() {
      this.showNews = false;
      this.startUp = false;
    },
  },

  created() {

  },
  watch: {
    list: {
      handler(newVal, oldVal) {
        if (!this.hasInit) {
          this.init();
          this.hasInit = true;
        }
      },
      deep: true,
    },
  },
};
</script>
</script>
<style lang="scss" scoped>
.rolling-wrap {
  box-sizing: border-box;
  width: 327px;
  height: 32px;
  margin: 0 auto;
  border-bottom: 1px solid rgba(0,0,0,0.05);
  /*padding-top: 8px;*/
  .roll-area {
    width: 100%;
    height: 16px;
    overflow: hidden;
    position: relative;
  }
  .roll-item-wrap {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 16px;
    line-height: 16px;
    &.downitem {
      /*transform: translateY(100%);*/
    }
  }
  .roll-type {
    display: inline-block;
    width: 32px;
    height: 16px;
    border-radius: 2px;
    text-align: center;
    font-size: 11px;
    color: #fff;
    position: absolute;
    left: 0;
    top: 0;
    &.news {
      background-color: #1588F4;
    }
    &.promo {
      background-color: #FA9D3B;
    }
  }
  .roll-title {
    display: inline-block;
    width: 260px;
    height: 16px;
    line-height: 16px;
    position: absolute;
    left: 40px;
    top: 0;
    font-size: 12px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .roll-icon-arrow {
    display: inline-block;
    width: 7px;
    height: 7px;
    border-top: 1px solid #000;
    border-right: 1px solid #000;
    transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
    opacity: 0.3;
    position: absolute;
    right: 4px;
    top: 4px;
  }
}
.news-wrap {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  color: #303030;
  z-index: 99999999;
  .mask {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    background: rgba(0,0,0,0.6);
  }
  &.hide {
    display: none !important;
  }
  .news-container {
    position: absolute;
    width: 100%;
    left: 0;
    transition: bottom 0.3s;
    &.active {
      bottom: 0;
    }
    &.inactive {
      bottom: -1000px;
    }
    .title-area {
      width: 100%;
      min-height: 64px;
      border-radius: 11px 11px 0 0;
      background: #fff;
      position: relative;
      .delete {
        width: 25px;
        height: 25px;
        font-size: 20px;
        position: absolute;
        left: 16px;
        top: 20px;
        text-align: center;
      }
      .title-text {
        padding-left: 50px;
        padding-top: 24px;
        padding-right: 20px;
        padding-bottom: 15px;
        font-size: 15px;
      }
    }
    .content-area {
      padding: 8px 16px;
      background: #fff;
      .time {
        font-size: 12px;
        color: #b1b1b1;
        margin-bottom: 12px;
      }
      .content-text {
        font-size: 14px;
        margin-bottom: 12px;
        line-height: 22px;
      }
      .source {
        font-size: 12px;
        color: #b1b1b1;
        margin-bottom: 25px;
      }
    }
  }
}
.lang_en .news,.lang_en .promo {
  font-size: 9px;
}
</style>
